App.filter('formOfEmploymentFilter', function () {
    var dictionary = {
        CONTRACT_OF_EMPLOYMENT: 'Umowa o pracę',
        CONTRACT_FOR_SPECIFIC_WORK: 'Umowa o dzieło',
        CONTRACT_OF_MANDATE: 'Umowa zlecenie',
        OTHER: 'Inny',
    };

    return function (el) {
        if(!el){
            return el;
        }

        return dictionary[el] || el;
    };
});
